var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = new Map();
    }
    EventEmitter.prototype.emit = function (event, msg) {
        var listeners = this.events.get(event) || [];
        for (var i = listeners.length - 1; i >= 0; i--) {
            var listener = listeners[i];
            listener.cb(msg);
            if (listener.once) {
                listeners.splice(i, 1);
            }
        }
    };
    EventEmitter.prototype.emitAsync = function (event, msg) {
        var listeners = this.events.get(event) || [];
        setTimeout(function () {
            for (var i = listeners.length - 1; i >= 0; i--) {
                var listener = listeners[i];
                listener.cb(msg);
                if (listener.once) {
                    listeners.splice(i, 1);
                }
            }
        });
    };
    EventEmitter.prototype.on = function (event, cb) {
        this.addListener(event, cb, false);
    };
    EventEmitter.prototype.once = function (event, cb) {
        this.addListener(event, cb, true);
    };
    EventEmitter.prototype.addListener = function (event, cb, once) {
        var listeners = this.events.get(event) || [];
        listeners.push({
            once: once,
            cb: cb,
        });
        this.events.set(event, listeners);
    };
    return EventEmitter;
}());
export { EventEmitter };
//# sourceMappingURL=index.js.map